export const isEmpty = (v) => v == null || (typeof v === 'string' && v.trim() === '');

export function validateVersionName(name) {
  if (isEmpty(name)) return 'Version name is required';
  if (name.length > 120) return 'Max length is 120 characters';
  return null;
}

export function validateFormats(arr) {
  if (!arr || arr.length === 0) return 'Select at least one format';
  return null;
}
